module.exports = __webpack_public_path__ + "img/tickets-r3-issues--network-security-internet.1bdd2644.png";